<template>
  <transition name="loading-fade">
    <div class="customize-loading" v-if="visible">
      <div class="loading-wrap">
        <span class="dot dot-spin"><i></i><i></i><i></i><i></i></span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'customize-loading',
  data() {
    return {
      visible: true
    }
  }
}
</script>

<style scoped lang="scss">
  .customize-loading {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10000;
    background-color: #fff;
    .loading-wrap {
      position: relative;
      display: flex;
      padding: 98px;
      justify-content: center;
      align-items: center;
      top: 50%;
      margin-top: -140px;
      .dot {
        animation: antRotate 1.2s infinite linear;
        transform: rotate(45deg);
        position: relative;
        display: inline-block;
        font-size: 32px;
        width: 32px;
        height: 32px;
        box-sizing: border-box;
        i {
          width: 14px;
          height: 14px;
          position: absolute;
          display: block;
          background-color: #666;
          border-radius: 100%;
          transform: scale(0.75);
          transform-origin: 50% 50%;
          opacity: 0.3;
          animation: antSpinMove 1s infinite linear alternate;
          &:nth-child(1) {
            top: 0;
            left: 0;
          }
          &:nth-child(2) {
            top: 0;
            right: 0;
            -webkit-animation-delay: 0.4s;
            animation-delay: 0.4s;
          }
          &:nth-child(3) {
            right: 0;
            bottom: 0;
            -webkit-animation-delay: 0.8s;
            animation-delay: 0.8s;
          }
          &:nth-child(4) {
            bottom: 0;
            left: 0;
            -webkit-animation-delay: 1.2s;
            animation-delay: 1.2s;
          }
        }
      }
    }

    .customize-loading-content {
      position: absolute;
      width: 100%;
      top: 50%;
      margin-top: -186px;
      text-align: center;
      i {
        margin-bottom: 20px;
        font-size: 32px;
      }
    }
  }

  .loading-fade-leave-active {
    animation: loading-fade-out .4s;
  }

  @keyframes loading-fade-out {
    0% {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
    100% {
      transform: translate3d(0, -20px, 0);
      opacity: 0;
    }
  }

  @keyframes antRotate {
  to {
    -webkit-transform: rotate(405deg);
    transform: rotate(405deg);
  }
}
@-webkit-keyframes antRotate {
  to {
    -webkit-transform: rotate(405deg);
    transform: rotate(405deg);
  }
}
@keyframes antSpinMove {
  to {
    opacity: 1;
  }
}
@-webkit-keyframes antSpinMove {
  to {
    opacity: 1;
  }
}
</style>